export default "__VITE_ASSET__CTjGkMt___"